"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBenchmarkPortfolio = exports.dispatchBenchmark = exports.BENCHMARK_PORTFOLIO_TOPIC = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const elements_core_rest_transport_1 = require("@hydrogen/elements.core.rest.transport");
const immer_1 = __importDefault(require("immer"));
const elements_core_event_bus_1 = require("@hydrogen/elements.core.event-bus");
const elements_data_wealth_app_use_contact_id_1 = require("@hydrogen/elements.data.wealth.app.use-contact-id");
const elements_data_wealth_app_use_investment_id_1 = require("@hydrogen/elements.data.wealth.app.use-investment-id");
const elements_core_i18n_1 = require("@hydrogen/elements.core.i18n");
exports.BENCHMARK_PORTFOLIO_TOPIC = 'BENCHMARK_PORTFOLIO_TOPIC';
const dispatchBenchmark = () => (0, elements_core_event_bus_1.post)(exports.BENCHMARK_PORTFOLIO_TOPIC, null);
exports.dispatchBenchmark = dispatchBenchmark;
const getBenchmark = (benchmark = [], modifiedBenchmark = []) => (benchmark === null || benchmark === void 0 ? void 0 : benchmark.map((item) => {
    var _a, _b;
    return (Object.assign(Object.assign({}, item), { selected: (_b = (_a = modifiedBenchmark.find((modifiedItem) => (modifiedItem.id === item.id))) === null || _a === void 0 ? void 0 : _a.selected) !== null && _b !== void 0 ? _b : item.selected }));
}));
const useBenchmarkPortfolio = (search = '') => {
    const [modifiedBenchmark, setModifiedBenchmark] = (0, react_1.useState)([]);
    const { language = 'en' } = (0, elements_core_i18n_1.useLanguage)();
    const contactId = (0, elements_data_wealth_app_use_contact_id_1.useContactId)();
    const investmentId = (0, elements_data_wealth_app_use_investment_id_1.useInvestmentId)();
    const queryParams = new URLSearchParams({
        searchTerm: search,
        language,
    }).toString();
    const queryKey = ['benchmark', queryParams, contactId, investmentId];
    const query = (0, react_query_1.useQuery)(queryKey, () => (0, elements_core_rest_transport_1.customApi)()
        .get(`/v1.0/widgets/clients/${contactId}/investments/${investmentId}/benchmarks?${queryParams}`).then((resp) => (resp.data)), {
        enabled: typeof contactId === 'number' && !!investmentId && search.length >= 3,
        refetchOnMount: 'always',
        keepPreviousData: false,
    });
    const changeBenchmark = (id, selected) => {
        setModifiedBenchmark((prev) => {
            const prevIndex = prev.findIndex((item) => item.id === id);
            if (prevIndex >= 0) {
                return (0, immer_1.default)(prev, (draft) => {
                    draft[prevIndex].selected = selected;
                });
            }
            return [...prev, { id, selected }];
        });
    };
    const addNewBenchmark = (id) => {
        changeBenchmark(id, true);
    };
    const removeBenchmark = (id) => {
        changeBenchmark(id, false);
    };
    const clear = () => {
        setModifiedBenchmark([]);
    };
    const save = (0, react_query_1.useMutation)(() => ((0, elements_core_rest_transport_1.customApi)().post(`/v1.0/widgets/clients/${contactId}/investments/${investmentId}/benchmarks`, modifiedBenchmark)), {
        onSettled: () => {
            query.remove();
            (0, exports.dispatchBenchmark)();
            clear();
        },
    });
    return Object.assign(Object.assign({}, query), { isLoading: query.isIdle || query.isLoading || query.isFetching, data: getBenchmark(query === null || query === void 0 ? void 0 : query.data, modifiedBenchmark), modifiedBenchmark, actions: {
            addNewBenchmark,
            removeBenchmark,
            save: () => {
                if (modifiedBenchmark.length === 0)
                    return;
                save.mutate();
            },
            clear,
        } });
};
exports.useBenchmarkPortfolio = useBenchmarkPortfolio;
//# sourceMappingURL=use-benchmark-portfolio.js.map